<template>
  <div>
    <div class="col-md-6 appinfopage">
      <h4 class="h4-title">Android Provider details</h4>
      <form v-on:submit.prevent="saveAndroidProviderDetail">
        <div class="form-group ">
          <label for="formGroupExampleInput">Key Id</label>
          <input
            type="text"
            class="form-control"
            id="serverKey"
            placeholder="Required"
            v-model="formAndroidProvider.serverKey"
          >
        </div>
        <hr />
        <div>
          <div class="form-group row">
            <div class="col-sm-2">
              <button
                type="submit"
                class="btn btn-primary"
              >{{saveButtonLabel || 'create'}}</button>
            </div>
            <div class="col-sm-2">
              <button
                type="button"
                class="btn btn-danger"
                @click="deleteProvider"
                v-if="pageMode===1"
              >Delete</button>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-lg-12">
              <b-alert
                show
                variant="success"
                v-if="saveDone"
              >Successfully saved.</b-alert>
              <b-alert
                show
                variant="danger"
                v-if="isError"
              >{{errorMessage}}</b-alert>

            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import AndroidProvider from '@/models/androidprovider.js';
export default {
  data () {
    return {
      appId: '',
      pageMode: 0, // 0 = Entry, 1 = Edit
      saveDone: false,
      formAndroidProvider: {},
      saveButtonLabel: 'Create',
      isError: false
    };
  },
  methods: {
    saveAndroidProviderDetail () {
      if (0 === this.pageMode) {
        // Create
        this.createAndroidProviderDetail();
      } else if (1 === this.pageMode) {
        // Update
        this.updateAndroidProviderDetail();
      }
    },
    createAndroidProviderDetail () {
      const androidProvider = new AndroidProvider(this.formAndroidProvider);
      const fd = new FormData();

      for (let key in androidProvider) {
        if (androidProvider[key]) {
          fd.append(key, androidProvider[key]);
        }
      }

      this.axios({
        method: 'post',
        url: (`${process.env.VUE_APP_URL_MESSAGING_API}/app/${this.appId}/android-provider`),
        data: fd
      }).then(res => {
        const respData = res.data;
        if ('Success' === respData.message) {
          this.saveDone = true;
          this.goToAppList();
        }
      })
        .catch(error => {
          this.isError = true;
          this.handleError(error);
        });
    },
    updateAndroidProviderDetail () {
      const androidProvider = new AndroidProvider(this.formAndroidProvider);
      const fd = new FormData();

      for (let key in androidProvider) {
        if (androidProvider[key]) {
          fd.append(key, androidProvider[key]);
        }
      }

      this.axios({
        method: 'patch',
        url: (`${process.env.VUE_APP_URL_MESSAGING_API}/app/${this.appId}/android-provider/${this.formAndroidProvider.id}`),
        data: fd
      }).then(res => {
        const respData = res.data;
        if ('Success' === respData.message) {
          this.saveDone = true;
          this.goToAppList();
        }
      })
        .catch(error => {
          this.isError = true;
          this.handleError(error);
        });
    },
    deleteProvider () {
      if (confirm('Are you sure to delete this provider detail?')) {
        this.axios({
          method: 'delete',
          url: (`${process.env.VUE_APP_URL_MESSAGING_API}/app/${this.appId}/android-provider/${this.formAndroidProvider.id}`)
        }).then(res => {
          const respData = res.data;
          if ('Success' === respData.message) {
            this.saveDone = true;
            this.goToAppList();
          }
        })
          .catch(error => {
            this.isError = true;
            console.log('Error :', error.response);
            this.handleError(error);
          });
      }
    },
    getAndroidProviderDetail () {
      this.appId = this.$route.params.id;
      this.axios.get(`${process.env.VUE_APP_URL_MESSAGING_API}/app/${this.appId}/android-provider/`, {
        headers: {
          Accept: 'application/json'
        }
      })
        .then(response => {
          const androidProvider = response.data.data.androidProvider;
          if (androidProvider) {
            this.formAndroidProvider = new AndroidProvider(androidProvider);
            this.pageMode = 1;
            this.saveButtonLabel = 'Update';
          }
        })
        .catch(error => {
          console.log(error);
          this.isError = true;
          this.handleError(error);
        });
    },
    goToAppList (id) {
      this.$router.push({ name: 'messaging-app-list' });
    },
    handleError (error) {
      if (error.response.data.data.length > 0) {
        this.errorMessage = error.response.data.data.map(value => value.msg).join(', ');
      } else {
        this.errorMessage = error.response.data.data.message;
      }
    }
  },
  created () {
    this.getAndroidProviderDetail();
    document.title = 'Admin Console: Android Provider Detail';
  }
};
</script>
